"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomContext = void 0;

var _react = require("react");

var ZoomContext = (0, _react.createContext)({
  scale: 1
});
exports.ZoomContext = ZoomContext;